import { render, staticRenderFns } from "./pointList.vue?vue&type=template&id=25d5b3a3&"
import script from "./pointList.vue?vue&type=script&lang=js&"
export * from "./pointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d5b3a3')) {
      api.createRecord('25d5b3a3', component.options)
    } else {
      api.reload('25d5b3a3', component.options)
    }
    module.hot.accept("./pointList.vue?vue&type=template&id=25d5b3a3&", function () {
      api.rerender('25d5b3a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/pointList.vue"
export default component.exports